import { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Grid, Typography } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';

import commonStyles from '../../../../styles';
import commonTheme from '../../../../styles/theme';
import LoadingEllipsis from '../../../pullRefComponent/parts/loadingEllipsis';
import { useLoading } from '../../../../../hooks';
import { INFO_CHANGE_HISTORY_LOADING } from '../../../../../constants/loading';
import CustomerCardItemSp from './customerCardItemSp';
import RegisterCustomerCardSp from './registerCustomerCardSp';
import PullRefComponent from '../../../pullRefComponent';
import { dateFormatter } from '../../../../../commonFunction';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: '17px 8px 124px 0',
    overflowY: 'auto',
    height: 'calc(100vh - 58px)',
    background: '#fff',
  },
  list: {
    paddingTop: 108,
    marginBottom: 80,
  },
  itemWrap: {
    '&.isGroup': {
      position: 'relative',
      marginTop: '-1px',
      zIndex: 1,
    },
  },
  date: {
    position: 'relative',
    background: '#fff',
    '&::before': {
      content: '""',
      display: 'block',
      background: '#C8C8C8',
      width: '100%',
      height: '1px',
      position: 'absolute',
      top: '50%',
    },
  },
  dateTxt: {
    position: 'relative',
    background: '#fff',
    display: 'inline-block',
    padding: '8px',
    color: '#8C8C8C',
  },
  button: {
    [commonTheme.breakpoints.down('sm')]: {
      zIndex: 1,
      minWidth: 'auto',
      padding: '0',
      position: 'fixed',
      bottom: '84px',
      right: '24px',
      width: '56px',
      height: '56px',
      backgroundColor: theme.palette.primaryColor,
      borderRadius: '50%',
      boxShadow:
        '0px 6px 6px rgba(51, 51, 51, 0.26), 0px 10px 20px rgba(51, 51, 51, 0.19)',
    },
  },
  addButton: {
    fontFamily: 'Roboto',
    color: theme.palette.primaryColor,
  },
  addIcon: {
    width: '15px',
    height: '15px',
    color: theme.palette.primaryColor,
    marginRight: '3px',
    [commonTheme.breakpoints.down('sm')]: {
      width: '24px',
      height: '24px',
      color: '#fff',
    },
  },
}));

function CustomerCardComponentSp(props) {
  const {
    getCustomerCards,
    postCustomerCards,
    getCustomerCardImage,
    cards,
    rerenderKey,
    customerId,
    refreshing,
  } = props;

  const classes = useStyles();
  const common = commonStyles();

  const { hasLoading } = useLoading();
  const isLoading = hasLoading(INFO_CHANGE_HISTORY_LOADING);

  const [open, setOpen] = useState(false);

  // 登録日時（画面を開いた時間で固定）
  const registrationDate = dateFormatter(new Date());

  const handleClick = () => {
    setOpen(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      await getCustomerCards();
    };
    fetchData();
  }, []);

  return (
    <Grid key={rerenderKey} className={classes.root}>
      {/* 更新箇所 */}
      <PullRefComponent
        refreshing={refreshing}
        onRefresh={getCustomerCards}
      >
        <Grid className={classes.list}>
          {cards ? cards.map((card, index) => {
            const indextDate = cards[index > 0 ? index - 1 : 0].registrationDate;
            const conditionA = index > 0 && card.registrationDate.split(/\s+/)[0] !== indextDate.split(/\s+/)[0];
            const conditionB = index === 0;
            return (
              <Grid className={`${classes.itemWrap} ${conditionA ? 'isGroup' : ''}`} key={card.cardId}>
                {/* 前データの日程と差分があったら日程を表示 */}
                {(conditionA || conditionB) && (
                  <Grid className={classes.date}>
                    <Typography className={`${common.title4} ${classes.dateTxt}`}>
                      {card.registrationDate}
                    </Typography>
                  </Grid>
                )}
                <CustomerCardItemSp card={card} getCustomerCardImage={getCustomerCardImage} />
              </Grid>
            );
          }) : null}
        </Grid>
      </PullRefComponent>
      <Button className={classes.button} onClick={handleClick}>
        <AddIcon className={classes.addIcon} />
      </Button>
      <RegisterCustomerCardSp
        open={open}
        setOpen={setOpen}
        onClose={() => setOpen(false)}
        customerId={customerId}
        postCustomerCards={postCustomerCards}
        getCustomerCards={getCustomerCards}
        registrationDate={registrationDate}
      />
      {/* ローディング用アイコン */}
      {isLoading && <LoadingEllipsis />}
    </Grid>
  );
}

export default CustomerCardComponentSp;
